import axiosPublicInstance from "module/common/utils/axiosConfig";
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "Active";
    SubscriptionStatus["Canceled"] = "Canceled";
    SubscriptionStatus["Expired"] = "Expired";
    SubscriptionStatus["PastDue"] = "Past Due";
    SubscriptionStatus["Pending"] = "Pending";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var postAuthLogin = function (payload) {
    return axiosPublicInstance.post("/api/auth/login", payload);
};
export var postAuthRegister = function (payload) {
    return axiosPublicInstance.post("/api/auth/register", payload);
};
export var postAuthVerify = function (_a) {
    var token = _a.token;
    return axiosPublicInstance.post("/api/auth/verify?token=".concat(token));
};
export var getUserInfo = function () {
    return axiosPublicInstance.get("/api/account/users/me");
};
export var postForgotPassword = function (payload) {
    return axiosPublicInstance.post("/api/auth/forgot-password", payload);
};
export var postResetPassword = function (payload) {
    return axiosPublicInstance.post("/api/auth/reset-password", payload);
};
export var getApiKeys = function () {
    return axiosPublicInstance.get("/api/account/current-api-keys");
};
export var postRotateApiKey = function (data) {
    return axiosPublicInstance.post("/api/account/rotate-api-key", data);
};
export var getTosAgreement = function () {
    return axiosPublicInstance.get("/api/account/tos_agreement");
};
export var postUpdateTosAgreement = function () {
    return axiosPublicInstance.post("/api/account/tos_agreement");
};
export var getPaymentMethodToken = function () {
    return axiosPublicInstance.get("/api/account/payment_method_token");
};
export var postPaymentMethod = function (data) {
    return axiosPublicInstance.post("/api/account/payment_method", data);
};
export var getCurrentSubscription = function () {
    return axiosPublicInstance.get("/api/account/current_subscription");
};
export var getPlans = function () {
    return axiosPublicInstance.get("/api/account/plans");
};
export var getAddOns = function () {
    return axiosPublicInstance.get("/api/account/addons");
};
export var postCancelAddon = function () {
    return axiosPublicInstance.post("/api/account/cancel_addon");
};
export var postUndoCancelAddon = function () {
    return axiosPublicInstance.post("/api/account/undo_cancel_addon");
};
export var postPurchaseAddon = function (data) {
    return axiosPublicInstance.post("/api/account/purchase_addon", data);
};
export var postUpgradeAddon = function () {
    return axiosPublicInstance.post("/api/account/modify_addon", { action: "upgrade" });
};
export var postDowngradeAddon = function () {
    return axiosPublicInstance.post("/api/account/modify_addon", { action: "downgrade" });
};
export var postPurchaseSubscription = function (data) {
    return axiosPublicInstance.post("/api/account/purchase_subscription", data);
};
export var postPurchaseUsageBlock = function (data) {
    return axiosPublicInstance.post("/api/account/purchase_usage_block", data);
};
export var getUsageBlockOptions = function () {
    return axiosPublicInstance.get("/api/account/usage_block_options");
};
export var postCancelSubscription = function () {
    return axiosPublicInstance.post("/api/account/cancel_subscription");
};
export var postUndoCancelSubscription = function () {
    return axiosPublicInstance.post("/api/account/undo_cancel_subscription");
};
export var postUpgradeSubscription = function () {
    return axiosPublicInstance.post("/api/account/modify_subscription", { action: "upgrade" });
};
export var postDowngradeSubscription = function () {
    return axiosPublicInstance.post("/api/account/modify_subscription", { action: "downgrade" });
};
export var patchAccount = function (payload) {
    return axiosPublicInstance.patch("/api/account", payload);
};
export var patchUser = function (payload) {
    return axiosPublicInstance.patch("/api/account/user", payload);
};
export var getChargeHistoryURL = function () {
    return axiosPublicInstance.get("/api/account/charge_history_url");
};
